// React:
import React from "react";
// MUI Components:
import { Box } from "@mui/material";
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from "@mui/material/CircularProgress";

const CircularLoader = (props: CircularProgressProps) => {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: "rgba(80,80,80,0.5)",
        }}
        size={props.size ? props.size : 40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: props.color
            ? props.color
            : (theme) => theme.palette.blue?.dark,
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={props.size ? props.size : 40}
        thickness={4}
        {...props}
      />
    </Box>
  );
};

const Loader = (props: CircularProgressProps) => {
  return <CircularLoader size={props.size} color={props.color} />;
};

export default Loader;
